export const numberSorter = (number1: number, number2: number) => (number1 < number2 ? -1 : 1);

export const numberSorterReversed = (number1: number, number2: number) =>
  number1 < number2 ? 1 : -1;
